import React, { Fragment } from "react";
import { Classification, Locale, Participant } from "../../core/api/model";
import { DashboardClassificationsListItem } from ".";

export interface DashboardClassificationsListProps {
  locale: Locale;
  classifications: Classification[];
  classificationsAll: Classification[];
  experts: Participant[];
  deleteClassification: (classificationId: number,) => void;
  editClassification: (classificationId: number, partId: number | undefined) => void;
}

export const DashboardClassificationsList = (props: DashboardClassificationsListProps) => {
  const [currentEdit, setCurrentEdit] = React.useState<number | null>();

  const onLockItems = (classificationId: number | null) => {
    setCurrentEdit(classificationId);
  }

  const checkDisabledState = (classificationId: number ): boolean => {
    return !!currentEdit && currentEdit !== classificationId
  }

  return (
    <Fragment>
      {props.classifications.length > 0 ? (
        // list
        <Fragment>
          {props.classifications.map((classification: Classification) => 
            <DashboardClassificationsListItem
              key={classification.classificationId}
              locale={props.locale}
              classification={classification}
              experts={props.experts}
              disabled={checkDisabledState(classification.classificationId)}
              lockItems={onLockItems}
              deleteClassificationForced={props.deleteClassification}
              editClassification={props.editClassification}
            />
          )}
        </Fragment>
      ) :
        // empty
        null
      }
    </Fragment>
  );
};
